export default function ScreenReaderText(props) {
  return(
    <span className="screen-reader-text">
      {props.content}
    </span>
  );
}
